import Page from "webPage/Page";

Page.register('page-template-integraciones', () => {

    $("body").on("submit", ".js-filter-form", function () {
        let keyword = $(this).find(".js-search-keywords").val().toLowerCase();

        let $items = $(".js-integration-item");

        let matched;
        let unmatched = [];
        if (keyword.length === 0) {
            matched = $items.get();
        } else {
            matched = [];

            $items.each((_, el) => {
                let $item = $(el);
                let name = $item.attr("data-name");

                if (name.toLowerCase().indexOf(keyword) !== -1) {
                    matched.push(el);
                } else {
                    unmatched.push(el);
                }
            });
        }
        matched = matched.sort(sortIntegrations);
        unmatched = unmatched.sort(sortIntegrations);

        let $matched = $(matched);
        let $unmatched = $(unmatched);

        $matched.removeClass("integration-logo--unmatched");
        $unmatched.addClass("integration-logo--unmatched");

        let $results = $(".js-integrations-results");

        $results.append($matched).append($unmatched);

        $("html, body").animate({
            scrollTop: $results.offset().top - $(".header").outerHeight() - 10,
        });

        return false;
    });
});


/**
 * @param {HTMLDivElement} a
 * @param {HTMLDivElement} b
 */
function sortIntegrations(a, b) {
    let aName = a.dataset.name;
    let bName = b.dataset.name;


    return aName.localeCompare(bName);
}
